<template>
  <div class="slide-section">
    <h2>
      Nuestros eventos:
    </h2>
    <div v-for="venue in getEventsFormatter" :key="venue.venue_id">
      <h3>{{ venue.venue_name }}</h3>
      <div class="flex flex-wrap">
        <event-card v-for="row in venue.events" :key="row.id"
          :event="row"
          :class="row === venue.events[0] ? 'pr-2' : 'px-2'"
          type="big"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useEvent } from "@/composables/useEvent";

import EventCard from "@/components/events/EventCard";
// import { Carousel, Slide, Navigation } from "vue3-carousel";

import { onMounted, computed } from 'vue';

const { events, getEvents } = useEvent();

const getEventsFormatter = computed(() => {
  const eventsArray = [];

  if (events.value && events.value.events) {
    eventsArray.push(...events.value.events.reduce((acc, event) => {
      const existVenue = acc.find(venue => venue.venue_id === event.venue.id);

      if (existVenue) {
        existVenue.events.push(event);
      } else {
        acc.push({
          venue_id: event.venue.id,
          venue_name: event.venue.name,
          events: [event]
        });
      }

      return acc;
    }, []));
  }
  
  return eventsArray;
});

onMounted(async ()=> {
  await getEvents();
});

</script>

<style lang="scss" scoped>

.slide-section {
  width: 100%;
  max-width: $maxWidthCarrousel;
  margin-left: auto;
  margin-right: auto;
  padding-top: 27px;
  padding-bottom: 59px;
  @media (max-width: 768px) {
    padding-top: 9px;
    padding-bottom: 14px;
  }
  h2 {
    font-size: $carrouselTitleSize;
    color: $carrouselTitleColor;
    padding-bottom: 12px;
  }
  h3 {
    font-size: 22px;
    color: $carrouselTitleColor;
    padding-bottom: 16px;
  }
}
</style>
